













import Vue from 'vue';
import CandidateService from '~/services/CandidateService';
import {
    CandidateJobBuilder,
    CandidateJobBuilderChangeEvent,
    commonProps,
    setupBuilder,
} from '~/utils/candidate';
import LinksForm from '../forms/LinksForm.vue';
import ProfileModal from './ProfileModal.vue';

export default Vue.extend({
    name: 'LinksModal',
    components: {
        ProfileModal,
        LinksForm,
    },
    props: {
        show: {
            type: Boolean,
            required: true,
        },

        ...commonProps(),
    },
    data() {
        return {
            builder: null as CandidateJobBuilder | null,
            service: new CandidateService(),

            formValid: true,
            isLoading: false,
            hasUnsavedChanges: false,
        };
    },
    computed: {
        saveDisabled(): boolean {
            return !this.hasUnsavedChanges || !this.formValid || this.isLoading;
        },
    },
    methods: {
        handleBuilderChange(evt: CandidateJobBuilderChangeEvent) {
            this.hasUnsavedChanges = !evt.empty;
        },
        async handleSave() {
            if (!this.builder || this.builder.isEmpty()) return;
            const request = this.builder.buildRequest();

            this.isLoading = true;
            await this.service
                .updateCandidateProfile(request)
                .then(() => this.$emit('close'))
                .finally(() => (this.isLoading = false));

            this.builder.reset();
        },
    },
    mounted() {
        const builder = setupBuilder.apply(this);
        builder.on('change', this.handleBuilderChange);
    },
    beforeDestroy() {
        if (this.builder) this.builder.off('change', this.handleBuilderChange);
    },
});
